import { API_DOMAIN } from "@monorepo/constants";
import {
  IReferral,
  IReferralConfirmPayload,
  IReferralConfirmResponse,
  IReferralResponse,
} from "@monorepo/types/services/referral";
import { createApi } from "@reduxjs/toolkit/query/react";

import { customBaseQuery } from "../../helpers/baseQuery";

export const referralApi = createApi({
  reducerPath: "referralApi",
  baseQuery: customBaseQuery<{ meta: IReferral }>({
    baseUrl: API_DOMAIN,
  }),
  tagTypes: ["Referral"],
  endpoints: (builder) => ({
    referral: builder.query<IReferral, void>({
      query: () => ({
        url: "/api/v1/recommendation",
      }),
      providesTags: ["Referral"],
      transformResponse: (response: { meta: IReferralResponse }) => {
        return {
          ...response?.meta,
          headerText: response?.meta["header-text"] ?? [],
        } as IReferral;
      },
      extraOptions: {
        serializeResponse: false,
      },
    }),

    confirmReferral: builder.mutation<IReferralConfirmResponse, IReferralConfirmPayload>({
      query: (payload) => ({
        url: "/api/v1/recommendation/confirm",
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const { useConfirmReferralMutation, useReferralQuery } = referralApi;

export default referralApi.reducer;
